/**
 * Simple event bus for handling export actions across components
 * This avoids storing functions in Redux state while maintaining functionality
 */
class ExportEventBus {
  constructor() {
    this.listeners = {};
  }

  on(eventType, listener) {
    if (!this.listeners[eventType]) {
      this.listeners[eventType] = [];
    }
    this.listeners[eventType].push(listener);
  }

  off(eventType, listener) {
    if (!this.listeners[eventType]) return;
    this.listeners[eventType] = this.listeners[eventType].filter(l => l !== listener);
  }

  emit(eventType, data) {
    if (!this.listeners[eventType]) return;
    this.listeners[eventType].forEach(listener => listener(data));
  }

  // Clear all listeners (useful for cleanup)
  clear() {
    this.listeners = {};
  }
}

// Create a singleton instance
export const exportEventBus = new ExportEventBus();
